import React, { useEffect } from 'react';
import { makeStyles } from "@material-ui/core/styles";
import toastError from "../../errors/toastError";

// Anúncio da Meta que originou a conversa, no padrão do WhatsApp Web: quadro suave com a
// miniatura, título e texto do anúncio; a mensagem do contato embaixo e a ação após um filete.
const useStyles = makeStyles((theme) => {
  const isDark = theme.palette.type === "dark";
  const link = isDark ? "#53bdeb" : "#027eb5";
  return {
    card: {
      minWidth: 240,
      maxWidth: 340,
      margin: "0 0 4px -3px",
      color: "inherit",
      whiteSpace: "normal",
    },
    ad: {
      display: "flex",
      alignItems: "stretch",
      gap: 10,
      borderRadius: 6,
      overflow: "hidden",
      backgroundColor: isDark ? "rgba(11,20,26,0.35)" : "rgba(11,20,26,0.06)",
    },
    thumb: {
      flex: "none",
      width: 84,
      minHeight: 84,
      objectFit: "cover",
    },
    adText: {
      flex: 1,
      minWidth: 0,
      padding: "8px 10px 8px 0",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      gap: 2,
      wordBreak: "break-word",
    },
    adTextNoThumb: {
      paddingLeft: 10,
    },
    title: {
      fontSize: 13.5,
      fontWeight: 600,
      lineHeight: "18px",
    },
    body: {
      fontSize: 12.5,
      lineHeight: "17px",
      opacity: 0.72,
      display: "-webkit-box",
      WebkitLineClamp: 3,
      WebkitBoxOrient: "vertical",
      overflow: "hidden",
    },
    messageUser: {
      padding: "7px 4px 8px",
      fontSize: 14.2,
      lineHeight: "19px",
      wordBreak: "break-word",
    },
    action: {
      display: "block",
      width: "100%",
      margin: 0,
      padding: "9px 8px",
      border: 0,
      borderTop: `1px solid ${isDark ? "rgba(233,237,239,0.14)" : "rgba(11,20,26,0.1)"}`,
      background: "transparent",
      color: link,
      font: "inherit",
      fontSize: 14,
      fontWeight: 500,
      textAlign: "center",
      cursor: "pointer",
      borderRadius: "0 0 6px 6px",
      "&:hover": {
        backgroundColor: isDark ? "rgba(255,255,255,0.05)" : "rgba(11,20,26,0.04)",
      },
      "&:focus-visible": {
        outline: `2px solid ${link}`,
        outlineOffset: -2,
      },
    },
  };
});

const AdMetaPreview = ({ image, title, body, sourceUrl, messageUser }) => {
  const classes = useStyles();
  useEffect(() => {}, [image, title, body, sourceUrl, messageUser]);

  const handleAdClick = async () => {
    try {
      if (sourceUrl && sourceUrl.trim() !== "") {
        window.open(sourceUrl);
      }
    } catch (err) {
      toastError(err);
    }
  };

  const hasValidImage = image && image.trim() !== "" && image.startsWith("data:image");
  const hasTitle = title && title.trim() !== "";
  const hasBody = body && body.trim() !== "";
  const hasMessageUser = messageUser && messageUser.trim() !== "";
  const hasUrl = sourceUrl && sourceUrl.trim() !== "";

  return (
    <div className={classes.card}>
      {(hasValidImage || hasTitle || hasBody) && (
        <div className={classes.ad}>
          {hasValidImage && (
            <img
              src={image}
              alt="Miniatura do anúncio"
              onClick={handleAdClick}
              className={classes.thumb}
              style={{ cursor: hasUrl ? "pointer" : "default" }}
            />
          )}
          <div className={hasValidImage ? classes.adText : `${classes.adText} ${classes.adTextNoThumb}`}>
            {hasTitle && <div className={classes.title}>{title}</div>}
            {hasBody && <div className={classes.body}>{body}</div>}
          </div>
        </div>
      )}

      {hasMessageUser && <div className={classes.messageUser}>{messageUser}</div>}

      {hasUrl && (
        <button type="button" className={classes.action} onClick={handleAdClick}>
          Ver anúncio
        </button>
      )}
    </div>
  );
};

export default AdMetaPreview;
